<template>
	<v-touch @swipeleft="swiperleft" @swiperight="swiperight" class="frame">
		<div class="container-box">
			<!-- 顶部 -->
			<div class="header">
				<tabBar class="tabBarStyle"></tabBar>
			</div>

			<!-- 内容 -->
			<div class="content">
				<div class="headerChild">
					<!-- <img src="../../assets/heisui.jpg" style="height: 100%; width: 100%; " @click="clickImg" /> -->
					<video id="myVideo" class="video-js" style="object-fit: contain;">
						<source src="https://slkjkg.com/video/666.mp4" type="video/mp4">
					</video>
				</div>
				<!-- 新闻标题 -->
				<div class="newsTitleFrame">
				  <div class="journalismTitle">
				    <div class="journalismChild">
				      <span>企业重大事件新闻</span>
				    </div>
				  </div>
				</div>
				<div class="contentFrame" v-for="(item, index) in list" :key="index">
					<div class="contentImg">
						<img :src="item.articlePicture" class="imgStyle" />
					</div>
					<div class="contentFont">
						<div class="contentTitle">
							<span>{{ item.articleTitle }}</span>
						</div>
						<div class="contentFooter">
							<div class="buttonStyle" @click="goRead(item.articleDetail)">
								<div class="elButton">
									<span>继续阅读</span>
								</div>
							</div>
							<!-- // 观看人数 -->
							<!-- <div></div> -->
							<div>
								<span>{{ item.articleDate }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<fixedBottomRight></fixedBottomRight>
		</div>
	</v-touch>
</template>

<script>
	import tabBar from "../../assembly/tabBarNew.vue";
	import swiper from "../../assembly/mobileSwiper.vue";
	import fixedBottomRight from '@/assembly/fixedBottomRight.vue';
	import { getArticleList } from "../../api/home.js";
	export default {
		name: "journalism",
		data() {
			return {
				tabBarTitle: "",
				tabBarTitle1: "",
				list: []
			};
		},
		components: {
			tabBar,
			swiper,
			fixedBottomRight
		},
		created() {
			getArticleList({
				articleType: 0
			}).then((res) => {
				console.log(res.data)
				// 赋值
				this.list = res.data
			})
		},
		mounted() {
			this.initVideo();
		},
		methods: {
			goRead(url) {
				if (url !== "") {
					window.location.href = url;
				}
			},
			swiperleft() {
				/* this.$router.push({
					name: 'contactUs'
				}) */
			},
			swiperight() {
				/* this.$router.push({
					name: 'cooperation'
				}) */
			},
			clickImg() {
				window.location.href = "https://mbd.baidu.com/newspage/data/videolanding?nid=sv_17222379004036174510"
			},
			initVideo() {
				//初始化视频方法
				let myPlayer = this.$video(myVideo, {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					//自动播放属性,muted:静音播放
					autoplay: "muted",
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: "auto",
					//设置视频播放器的显示宽度（以像素为单位）
					width: "100%",
					//设置视频播放器的显示高度（以像素为单位）
					height: "100%"
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	.frame {
		position: absolute;
		height: 100%;
		width: 100%;
		touch-action: pan-y !important;
	}

	.container-box {
		display: flex;
		flex-direction: column;

		.imgStyle {
			height: 100%;
			width: 100%;
		}

		.header {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			position: fixed;
			background-color: #fff;
			height: 7.5vh;
			width: 100%;
			z-index: 999;
			opacity: 0.85;
			.headerChild {
				height: 59%;
				width: 100vw;
			}

			.tabBarFontFrame {
				pointer-events: none;
				color: #fff;
				height: 5vh;
				width: 100%;
				position: absolute;
				top: 24vh;
				z-index: 3;
				display: flex;
				align-items: center;
				flex-direction: column;

				.tabBarFont {
					letter-spacing: 2px;
					font-weight: bold;
					font-size: 1.3rem;
				}

				.tabBarFont1 {
					margin-top: 2%;
					font-size: 1rem;
					letter-spacing: 2px;
				}
			}
		}

		.newsTitleFrame {
			width: 100%;
			display: fixed;
			background-color: #fff;

			.journalismTitle {
				display: flex;
				flex-direction: column;
				justify-content: center;
				padding: 1.5rem 0.5rem;
				border-bottom: solid 2px gray;
				width: 70%;
				margin-left: 0.5rem;
				margin-bottom: 0.5rem;

				.journalismChild {
					height: 0.2rem;
					border-left: solid 10px #7b0000;
					font-weight: bold;
					padding-left: 0.6rem;
					padding-bottom: 1.2rem;
					letter-spacing: 0.2rem;
				}
			}
		}

		//  内容
		.content {
			margin-top: 7.5vh;
			width: 100vw;

			.contentFrame {
				display: flex;
				align-items: center;
				justify-content: space-between;
				height: 14vh;
				margin: 0.5rem;

				.contentImg {
					display: flex;
					height: 90%;
					width: 40%;
				}

				.contentFont {
					display: flex;
					flex-direction: column;
					justify-content: center;
					height: 100%;
					width: 58%;

					.contentTitle {
						height: 70%;
						width: 100%;
						display: flex;
						flex-wrap: wrap;
						overflow: hidden;
						font-size: 1.03rem;
					}

					.contentFooter {
						display: flex;
						justify-content: space-between;
						align-items: center;
						height: 30%;
						font-size: 0.1rem;

						.buttonStyle {
							border: solid 1px;
							cursor: pointer;
						}

						.elButton {
							display: flex;
							justify-content: center;
							align-items: center;
							padding: 0.3rem;
						}
					}
				}
			}
		}
	}
	.video-js {
		width: 100%;
		height: 220px;
	}
</style>


// WEBPACK FOOTER //
// src/components/iphone/journalism.vue